import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { CONTENT } from "@/content";
import { fileUrl, fmtDate, getAnonId, publicGet, useApi } from "@/lib/api";
import { ShareRow } from "@/components/share/ShareRow";

const C = CONTENT.contentView;

const useVisit = (ref) => {
  const api = useApi();
  useEffect(() => {
    if (!ref || localStorage.getItem(`os_v_${ref}`)) return;
    localStorage.setItem(`os_v_${ref}`, "1");
    api("post", "/visits", { ref, anon_id: getAnonId() }).catch(() => {});
  }, [ref, api]);
};

export default function ContentView() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const [item, setItem] = useState(undefined);
  useVisit(params.get("r"));
  useEffect(() => { setItem(undefined); publicGet(`/content/${slug}`).then(setItem).catch(() => setItem(null)); }, [slug]);
  useEffect(() => {
    if (!item) return;
    const prev = document.title;
    document.title = `${item.title} | ONE SHARE`;
    return () => { document.title = prev; };
  }, [item]);

  if (item === undefined) return <main className="page reader" />;
  if (item === null) return (
    <main className="page reader" data-testid="content-not-found">
      <div className="nb-card cta-card"><p className="cta-line">{C.notFound}</p><Link to="/library" className="nb-btn">{C.notFoundButton}</Link></div>
    </main>
  );

  return (
    <main className="page reader" data-testid="content-view">
      <Link to="/library" className="text-link back-link" data-testid="back-to-library-link">{C.back}</Link>
      <div className="row-tags">
        {item.category && <span className="pill">{item.category}</span>}
        <span className="row-date">{fmtDate(item.publish_date)}</span>
      </div>
      <h1 className="reader-title" data-testid="content-title">{item.title}</h1>
      {item.embed_src ? (
        <div className="embed-frame" data-testid="content-embed"><iframe src={item.embed_src} title={item.title} allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen loading="lazy" /></div>
      ) : item.image_path && (
        <img className="reader-image" src={fileUrl(item.image_path)} alt={item.title} data-testid="content-image" />
      )}
      <section className="verse-card reader-verse" data-testid="content-verse">
        <p className="verse-text">{item.verse_text}</p>
        <p className="verse-ref">{item.verse_reference}</p>
        {item.translation && <p className="verse-note">{item.translation}</p>}
      </section>
      {item.message && <p className="reader-message" data-testid="content-message">{item.message}</p>}
      <hr className="reader-divider" />
      <ShareRow item={item} />
    </main>
  );
}
